import { selector } from "recoil";
import { layerDefs } from "../layerDefs";
import { visibleLayerIDsSelector } from "./visibleLayerIDsSelector";

export const visibleMapLayersWithPopupSelector = selector({
  key: "visible-map-layers-with-popup-selector",
  get: ({ get }) => {

    const hasPopupAttributes = (layerID) => {
      return !!layerDefs[layerID]?.popupAttributes?.length > 0
    }

    const hasPopupType = (layerID) => {
      return !!layerDefs[layerID]?.popupType
    }

    return get(visibleLayerIDsSelector)
      .filter((id) => hasPopupAttributes(id) || hasPopupType(id))
      .reduce((acc, id) => {
        acc[id] = layerDefs[id].popupLayers || [id]
        return acc
      }, {});
  },
});
